import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import CustomButton from "../ui/CustomButton";
import { AppImages, AppSVG } from "../../common/ImagePath";

const RulesModal = ({ isOpen, onClose, gameName, gameMetaData }) => {
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
            setCurrentSlide(0);
        } else {
            document.body.style.overflow = "unset";
        }
        return () => {
            document.body.style.overflow = "unset";
        };
    }, [isOpen]);

    // Get slides for the current game
    const slides = gameMetaData?.lobbyMeta?.[gameName]?.howToPlay?.slides || [];
    const totalSlides = slides.length;

    const nextSlide = () => {
        if (currentSlide < totalSlides - 1) {
            setCurrentSlide(currentSlide + 1);
        } else {
            onClose();
        }
    };

    const replaySlides = () => {
        setCurrentSlide(0);
    };

    if (!isOpen || !totalSlides) return null;

    const currentSlideData = slides[currentSlide];

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center px-4">
            <div
                className="absolute inset-0 bg-black/80 backdrop-blur-sm"
                onClick={onClose}
            />

            <div className="relative w-full max-w-md bg-[#121212] rounded-3xl border border-white/10 shadow-2xl overflow-hidden">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 p-2 hover:bg-white/10 rounded-full text-white"
                >
                    <X className="w-5 h-5" />
                </button>

                <div className="flex flex-col max-h-[80vh]">
                    <div className="p-4">
                        <h2 className="text-2xl font-saira font-extrabold text-white text-center">
                            HOW TO PLAY
                        </h2>
                    </div>

                    <div className="flex justify-center items-center px-4 py-2">
                        {currentSlideData?.imageUrl && (
                            <img
                                src={currentSlideData.imageUrl}
                                alt={`Step ${currentSlide + 1}`}
                                className="max-h-[180px] md:max-h-[220px] object-contain rounded-xl"
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = AppImages.noImageAvailable;
                                }}
                            />
                        )}
                    </div>

                    <div className="px-6 py-3">
                        <div className="max-h-[180px] md:max-h-[220px] overflow-y-auto pr-2">
                            <p className="text-lightGray text-xs sm:text-base font-normal leading-4 whitespace-pre-line">
                                {currentSlideData?.description?.trim() || "No description available"}
                            </p>
                        </div>
                    </div>

                    <div className="p-4 flex flex-col items-center gap-6">
                        <CustomButton
                            onClick={nextSlide}
                            className="w-full py-[9.5px] font-saira font-extrabold text-blackShade4 flex justify-center items-center"
                        >
                            {currentSlide === totalSlides - 1 ? ("I'M READY!") : (<> NEXT <img src={AppSVG.arrowRight} alt="arrow" className="inline-block ml-2 w-4 h-4" /> </>)}
                        </CustomButton>

                        {currentSlide === totalSlides - 1 && (
                            <button
                                onClick={replaySlides}
                                className="flex items-center gap-2 hover:scale-95 transition text-xs sm:text-sm"
                            >
                                <img src={AppSVG.restart} alt="arrow" className="inline-block w-3 h-[13px] sm:w-4 sm:h-4" />
                                Replay
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RulesModal;
